import axios from "axios";

export function request(config) {
  //1.创建axios实例
  const instance = axios.create({
    // baseURL: "http://127.0.0.1:5000/",
    /*baseURL:'http://192.168.2.184:5000/',*/
    // baseURL:'http://192.168.2.115:5000/',
   // baseURL: "http://121.36.22.148:5000/",
    baseURL: "http://dqb-1688.com:5000/",   
    timeout: 0,
  });

  //2.axios的拦截
  //2.1请求拦截
  instance.interceptors.request.use(
    (config) => {
      return config;
    },
    (err) => {
      console.log(err);
    }
  );

  //2.2响应拦截
  instance.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (err) => {
      console.log(err);
    }
  );

  //3.发送网络请求
  return instance(config);
}
